<script>
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import PageHeader from '@components/page-header'
import Multiselect from 'vue-multiselect'

export default {

	page: {
		title: 'Новая страна',
		meta: [{ name: 'description', content: appConfig.description }],
	},

	components: { Layout, PageHeader, Multiselect },

	data() {
        return {
			title: 'Новая страна',
			items: [],
            trackBy: 'id',

			name: null,
            code: null,
		}
	},
    
	watch: {

	},

	computed: {
	    item(){
            return this.$store.getters['countries/GET_COUNTRIES_ITEM'];
        },
        session_user_item(){
            let session = this.$store.getters['sessions/GET_SESSIONS_ITEM'];
            return session.user ? session.user : null;
        },
	},

	async mounted() {

        this.item_uuid = this.$route.params.uuid ? this.$route.params.uuid : '';

        await this.$store.dispatch('countries/FETCH_COUNTRIES_LIST', {});
        this._options = this._list_data;

        if(this.item_uuid !== ''){
    
            this.title = 'Редактирование страны';
            document.title = 'Редактирование страны' + ' | ' + appConfig.title;
    
            await this.$store.dispatch('countries/FETCH_COUNTRIES_ITEM', {'uuid': this.item_uuid});

            this.name = this.item.name ? this.item.name : null;
            this.code = this.item.code ? this.item.code : null;
        }
	},

	methods: {
        async saveItem(){

            let data_send = {
                'name': this.name,
                'code': this.code,
            };

            let result = '';

            if(this.item_uuid === ''){
                result = await this.$store.dispatch('countries/FETCH_COUNTRIES_CREATE', data_send);
            } else {
                data_send.uuid = this.item_uuid;
                result = await this.$store.dispatch('countries/FETCH_COUNTRIES_UPDATE', data_send);
            }

            if(result === false){
                alert('Возникла ошибка');
            } else {
                this.$router.push({ name: 'Countries'});
            }

        }
	}
}
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />
        <b-form
            class="form-horizontal"
            @submit.prevent="saveItem"
        >
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                            <div class="row">
                                <div class="col">
                                    <b-form-group
                                        label="Название страны"
                                        label-for="name"
                                    >
                                        <b-form-input
                                            id="name"
                                            v-model="name"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>

                                    <b-form-group
                                        label="Код"
                                        label-for="code"
                                    >
                                        <b-form-input
                                            id="code"
                                            v-model="code"
                                            placeholder=""
                                        ></b-form-input>
                                    </b-form-group>
                                </div>
                            </div>
                    </div>
                    <hr style="margin-bottom: 0px !important; margin-top: 0px !important">
                    <div style="padding: 0.75rem">
                        <button type="submit" class="btn btn-primary">Сохранить</button>
                    </div>
                    <!-- end card-body -->
                </div>
                <!-- end card-->
            </div>
            <!-- end col -->
        </div>
        </b-form>
	</Layout>
</template>
